import { DateTime } from 'luxon';

export function setZoneKeepTime(isoTimeStamp: string | Date, timeZone: string) {
  const date = DateTime.fromISO(isoTimeStamp.toString(), { setZone: true });
  const newDate = DateTime.local().setZone(timeZone).set(date.toObject());

  return newDate.toISO();
}
